import pictures from '../../assests/assestimport.js';
const {gp} = pictures;

const gloves=[
    {
        id:1,
        label:'92-600',
        subcategory:"Disposable Gloves", 
        sublink:"disposablegloves",  
        band:"Ansell",
        description:`ANSELL - Glove TNT Disposable Nitrile Size Small - Extra Large (XL) BluEAdvanced chemical resistance: With
        TNT Technology for ultimate
        protection
        Superior comfort: Extra-soft, smooth
        feel, boosting comfort for extended
        wear
        Outstanding durability: Proprietary
        nitrile resists rips and tears`,
        image:gp[0],
        alt:"ANSELL 92-600 TNT Disposable Nitrile glove, chemical resistant gloves",
        hscode:'',
    },
    {
        id:2,
        label:'82-133',   
        band:"Ansell",
        description:`ANSELL - Gloves EDGE Thinner nitrile - Blue -6.5 - 9.5 Comfortable fit: This disposable, nitrile glove has a thin formulation for reliable protection, plus improved comfort and flexibility
        Secure grip: The textured fingertips of the glove provide an improved grip for a variety of applications
        Smart packaging: Packed with 300 gloves per dispenser box* to provide additional value and convenience`,
        image:gp[1],
        alt:"ANSELL 92-605 Glove EDGE Thinner nitrile - Blue -6.5 - 9.5, chemical resistant gloves",
        hscode:'',
    },
    {
        id:3,
        label:'37-675',   
        band:"Ansell",
        description:`ANSELL - Gloves Solvex size 7- 11 (1x144) Versatile, high performance chemical handling glove.
        Nitrile compound material provides outstanding chemical resistance and strength.
        Flocked cotton inner provides comfort in use.
        Reusable with excellent abrasion resistance.
        FDA compliant – suitable for food handling.`,
        image:gp[2],
        alt:"Ansell 37-675 Glove Solvex size 7- 11 (1x144), chemical resistant gloves",
        hscode:'',
    },
    {
        id:4,
        label:'37-695',   
        band:"Ansell",
        description:`ANSELL - Gloves Solvex size 7-11 (1x72)   Food processing involving direct contact with food
        Handling incoming and outgoing goods
        Delivering parts to a production line
        Forging operations
        General pumping work
        Draining pumps valves or lines
        Filling, blending, and charging raw materials`,
        image:gp[3],
        alt:"Ansell 37-695 Solvex glove, chemical resistant gloves",
        hscode:'',
    },
    {
        id:5,
        label:'11-801',
        subcategory:"Industrial Gloves",
        sublink:"industrialgloves",
        band:"Ansell",
        description:`HyFlex 11-801 glove provides safety and dexterity for a broad range of industries and applications. 
        The ergonomic design provides unsurpassed comfort while providing grip and protection for applications like 
        assemling, packaging, carpentry, and general maintenance and mechanical work. Available in a wide range of 
        sizes (XS-6 thru XXL-11)`,
        image:gp[4],
        alt:"Ansell HyFlex 11-801 mechincal glove",
        hscode:'',
    },
    {
        id:6,
        label:'11-840',   
        band:"Ansell",
        description:`ANSELL - Gloves Hyflex  size  11 (1 x 144)`,
        image:gp[5],
        alt:"Ansell 11-840 Hyflex glove",
        hscode:'',
    },
    {
        id:7,
        label:'14-663',   
        band:"Ansell",
        description:`ANSELL - Gloves superflex gloves
        PVC coating: Protective gloves with optimized comfort and flexibility
        Non-slip finish: Gloves with grip enhanced by rough, non-slip surface
        CE compliance: For assured safety and high-quality work gloves`,
        image:gp[6],
        alt:"Ansell 14-663 superflex glove",
        hscode:'',
    },
    {
        id:8,
        label:'48-126',
        band:"Ansell",
        description:`ANSELL - Gloves Edge Size 7-11 (1x12)
        Black exterior: Economical industrial gloves with longer wear life
        Seamless design: Form-fitting, high-dexterity hand protection gloves`,
        image:gp[7],
        alt:"Ansell 48-126 edge glove",
        hscode:'',
    },
    {
        id:9,
        label:'HyFlex® 11-727',
        band:"Ansell",
        description:`Ultralight abrasion-resistant gloves that offer barehand comfort, dexterity and protection
        Lightweight fabric and seamless liner: For a flexible, tailored fit
        INTERCEPT™ Cut Resistance Technology: Ensuring workplace safety`,
        image:gp[8],
        alt:"Ansell HyFlex® 11-727 ultralight abrasion-resistant glove",
        hscode:'',
    },
    {
        id:10,
        label:'EDGE® 82-144', 
        band:"Ansell",
        description:`Reliable protection elasticity and comfort gloves`,
        image:gp[9],
        alt:"Ansell EDGE® 82-144 Reliable protection elasticity and comfort glove",
        hscode:'',
    },
    {
        id:11,
        label:'48-128',  
        band:"Ansell",
        description:`ANSELL - Edge Nitrile Coated Gloves, Size: 8-10`,
        image:gp[10],
        alt:"Ansell 48-128 Edge Nitrile Coated glove",
        hscode:'',
    },
    {
        id:12,
        label:'48-305',   
        band:"Ansell",
        description:`ANSELL - Gloves Edge Size 7- 10 (1x144)`,
        image:gp[11],
        alt:"Ansell 48-305 edge glove",
        hscode:'',
    },
    {
        id:13,
        label:'48-701',   
        band:"Ansell",
        description:`ANSELL - Edge  Gloves, Size: 7-10`,
        image:gp[12],
        alt:"Ansell 48-701 edge glove",
        hscode:'',
    },
    {
        id:14,
        label:'48-705',   
        band:"Ansell",
        description:`ANSELL - Knitted Spandex Nylon Glass Fiber Palm Dipped gloves, Size: 8,9,10`,
        image:gp[13],
        alt:"Ansell 48-705 knitted spandex nylon glass fiber pam dipped glove",
        hscode:'',
    },
    {
        id:15,
        label:'HyFlex® 11-727',
        band:"Ansell",
        description:`Ansell Ultralight abrasion-resistant gloves that offer barehand comfort, dexterity and protection`,
        image:gp[14],
        alt:"Ansell HyFlex® 11-727 Ultralight abrasion-resistant glove",
        hscode:'',
    },
    {
        id:16,
        label:'ActivArmr® 43-216',   
        band:"Ansell",
        description:`Heat-resistant industrial gloves, fortified for advanced hand protection in demanding tasks`,
        image:gp[15],
        alt:"Ansell ActivArmr® 43-216 Heat-resistant industrial glove",
        hscode:'',
    },
    {
        id:17,
        label:'MICROFLEX® 93-143 ',   
        band:"Ansell",
        description:`Durable protection in a comfortable, versatile glove`,
        image:gp[16],
        alt:"Ansell MICROFLEX® 93-143 glove",
        hscode:'',
    },
    {
        id:18,
        label:'AlphaTec® Solvex® 37-675',   
        band:"Ansell",
        description:`Thin, versatile chemical-resistant gloves that deliver comfortable hand protection`,
        image:gp[17],
        alt:"Ansell AlphaTec® Solvex® 37-675 glove",
        hscode:'',
    },
    {
        id:19,
        label:'EDGE® 48-920',   
        band:"Ansell",
        description:`Cost effective solution for light weight applications requiring excellent grip and strong oil-repellence`,
        image:gp[18],
        alt:"Ansell EDGE® 48-920 glove",
        hscode:'',
    },
    {
        id:20,
        label:'AlphaTec® Solvex® 37-676',   
        band:"Ansell",
        description:`Comfortable chemical-resistant gloves, delivering highly durable personal protection in a wide range of applications`,
        image:gp[19],
        alt:"Ansell AlphaTec® Solvex® 37-676 glove",
        hscode:'',
    },
    {
        id:21,
        label:'Fire Resistant Gloves',   
        band:"Chiba",
        description:`CHIBA FIRE FIGHTING GLOVES
        Rescue II specifications:
        Backhand: fire resistant, Nappa leather
        Palmhand: fire resistant, Nappa leather
        Gauntlet: Split leather
        Finger liner: 100% Twaron, knitted fabric
        Gauntlet liner: 70% Nomex, 30% Viscose
        Waterproof/Breathable: 6.000 mm water column, 7.500g/m2/24h breathability
        heat resistant, EN659: 2003 + A1:2008, Chiba, Germany
        Size: 9 - 10 - 11`,
        image:gp[20],
        alt:"Chiba Fire Resistant glove",
        hscode:'',
    },
    {
        id:22,
        label:'Chiba FireFighter Rescue Gloves',   
        band:"Chiba",
        description:`FireFighter Rescue Gloves - finger glove made of hydrophobic, heat-resistant 
        cowhide nappa leather with split leather cuff (adjustable by a strap with Velcro).the cuff is 
        sewn with a yellow, flame - resistant, 50mm reflective stripe.`,
        image:gp[21],
        alt:"Chiba FireFighter Rescue glove",
        hscode:'',
    },
    {
        id:23,
        label:'ISU4544EP',
        band:"Shareef Tex",
        description:`Sandy Nitrile finish with extra padding for Excellent
        grip in wet, dry & oily conditiont
        Black TPR chips on back for super anti impact protection
        Velcro hook & loop closure at the wrist to provide a snug custom fit
        Reinforced thumb crotch for extended glove life, enhanced comfort, increased abrasion resistanc
        High Visibility for increased safety
        Touchscreen compatible fingertips
        Ideal applications
        Oil & Gas Industry
        Heavy Construction Work
        Handling Heavy Duty Tools`,
        image:gp[22],
        alt:"Sand nitrile glove with extra padding for excellent grip in wet, dry & oily conditiont glove",
        hscode:'',
    },
    {
        id:24,
        label:'KONG® ORIGINAL SDX2',   
        band:"Ironclad",
        description:`KONG ORIGINAL - 4242AP
        Double Layer Synthetic Leather Dotted Palm
        Breathable Nylon Back of Hand
        Patented “pinch protection” on the fingertips
        Patented maximum coverage impact
        protection on fingers, thumb, knuckles and
        metacarpal boness
        High dexterity and Abrasion, most
        comfortable impact glove
        IVE™ patent pending optical technology that
        extends the field of visual recognition`,
        image:gp[23],
        alt:"KONG® ORIGINAL SDX2 Double Layer Synthetic Leather Dotted Palm Breathable Nylon Back of Hand glove",
        hscode:'',
    },
    {
        id:25,
        label:'KONG® DECK CREW A4 KDC5',   
        band:"Ironclad",
        description:`KONG DECK CREW - 4X44EP
        DuPont™ Teflon® Treatment
        Exclusive CT5™ Cut Resistant Material
        4 Layer Design
        KONG® Metacarpal Protection
        KONG® Knuckle Protection
        KONG® Patented Finger Protection`,
        image:gp[24],
        alt:"KONG® DECK CREW A4 KDC5 ",
        hscode:'',
    },
    {
        id:26,
        label:'KONG® 360° A5 IVE KKCA5',   
        band:"Ironclad",
        description:`Sandy Nitrile Coated Palm
        13 Gauge HPPE Blended Knit
        Patented IVE™ Full TPR
        Duraclad® Reinforced Thumb Saddle
        Applications of usage Oil & Gas Drilling, Extraction, & Refining
        Fracking
        Tool Pushing
        Mining
        Demolition
        Heavy Construction
        Rigging`,
        image:gp[25],
        alt:"KONG® 360° A5 IVE KKCA5 Sandy Nitrile Coated Palm glove",
        hscode:'',
    },
    {
        id:27,
        label:'VIBRATION IMPACT WWI2',   
        band:"Ironclad",
        description:`KONG ANTI VIBRATION
        Ergonomic gel palm pads
        Contour grip palm design
        Terry Cloth Sweat Wipe
        TPR cuff puller for ease of donning`,
        image:gp[26],
        alt:"VIBRATION IMPACT WWI2 Ironclad glove",
        hscode:'',
    },
    {
        id:28,
        label:'CUTSHIELD gloves ISU4X42CT',   
        band:"ishieldu",
        description:`
        Polyurethane coating gives the gloves flexibility and fit, Black nylon grey PU palm gloves for heavy duty applications.
        Breathable back of hand to reduce perspiration. Polyurethane coating offers excellent grip & extra durability
        Perfect for handling small components & carrying out precision works
        Applications: Loading and unloading Items, Accessories & spare parts Items, Maintenance works, Equipment Handling, Precision Handling`,
        image:gp[27],
        alt:"Cutshield ISU4X42CT ishieldu glove",
        hscode:'',
    },
    {
        id:29,
        label:'Air shield ISU4131AS',   
        band:"ishieldu",
        description:`Air shield Gloves
        Knitted black nylon coated black PU palm glove for light weight applications, 
        PU coating provides the exceptional grip Touchscreen compatible fingertips
        Polyurethane coated palm for great abrasion resistance,
        Elasticated kintted wrist provides secure & comfortable fit, Seamless liner offers increased comfort & breathability
        Applications: Glass Handling, Automatic Manufacturing, Construction, Sharp Materials Handling, Component Handling`,
        image:gp[28],
        alt:"Ishieldu Air shield Glove ISU4131AS",
        hscode:'',
    },
    {
        id:30,
        label:'Chem shield ISU3101CM',   
        band:"ishieldu",
        description:`CHEM SHIELD A heavy
        duty chemical resistant flock lined nitrile butadiene glove for chemical and heavy duty applications.
        Nitrile compound provides an outstanding combination of chemical resistance and strength. 
        CHEMSHIELD A heavy duty chemical resistant flock lined nitrile butadiene glove for chemical and heavy duty applications.
        Applications: Painting, Cleaning & Janitorial, Chemical Handling, Automotive Maintenance`,
        image:gp[29],
        alt:"Ishieldu Chem Shield ISU3101CM glove",
        hscode:'',
    },
]

export default gloves;